(function($){
    $('.platek-faq .item .question').on('click', function(){
        $(this).next('.answer').slideToggle(500);
        $(this).toggleClass('active');
    })
})(jQuery)